import * as React from 'react';
import { observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import Page from '@src/components/page';
import PageLayout from '@src/business-components/page-layout';
import VideoList from './components/video-list';
import AuditionVideoStore from './store';
import aos from '@src/utils/aos';

const styles = require('./index.less');

const AuditionVideo = () => {
  const store = useStore(() => new AuditionVideoStore());
  return (
    <Page className={styles.mediaVideoRoot}>
      <PageLayout store={store.pageLayoutStore} title={<span className={styles.title} />}>
        <div className={styles.content} {...aos.FADE_UP()}>
          <VideoList store={store.videoListStore} />
        </div>
      </PageLayout>
    </Page>
  );
};

export default observer(AuditionVideo);
